import React, { useContext } from "react";

import LoyaltyCampaign from "../../LoyaltyCampaign";
import Layout from "../../Layout";
import Share from "../../Share";
import Money from "../../Money";
import { ToolContext } from "../ToolProvider";
import DonationCard from "../DonationCard";
import PrintButton from "../../PrintButton";
import EntryNumbers from "./EntryNumbers";
import * as UI from "./ui";

const ReceiptStep = ({ nonprofit, sweepstakes }) => {
  const { paymentIntent, donationLevel, donor, promoCode } = useContext(ToolContext);

  return (
    <React.Fragment>
      <Layout.FullWidth fold id="receipt">
        <PrintButton position="header" />
        <Layout.FullWidthColumn>
          <UI.Heading>Thank you for your donation</UI.Heading>
        </Layout.FullWidthColumn>
        <Layout.FixedColumn span={5} breakpoint="belowTablet" style={{position: "relative"}}>
          <DonationCard donationLevel={donationLevel} promoCode={promoCode} donor={donor} />
          <PrintButton position="card" />
        </Layout.FixedColumn>
        <Layout.FlexibleColumn span={[7,15]} breakpoint="belowTablet" spaced>
          <LoyaltyCampaign sweepstakes={sweepstakes} donor={donor} />
          <UI.ThankYou>
            Thank you for your donation!
          </UI.ThankYou>
          <EntryNumbers donationId={paymentIntent.donationId} />
          <UI.Message>
            We sincerely appreciate your support of {nonprofit.name}, EIN {nonprofit.ein}.
            A donation receipt including your official sweepstakes entries has been emailed to you.
            Please print your email receipt and keep it in a safe place.
            Your sweepstakes entries have been placed in the official sweepstakes entry pool.
          </UI.Message>

          <UI.ShareCTA>Please share your donation with your friends and help support our cause.</UI.ShareCTA>
           <Share receipt />
          <UI.HiddenAmount id="receipt-amount">
            <Money cents={donationLevel.price} format="0.00" />
          </UI.HiddenAmount>
        </Layout.FlexibleColumn>
      </Layout.FullWidth>
    </React.Fragment>
  );
}

export default ReceiptStep;
